<!-- eslint-disable -->
<template>
  <div>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :loading="loading"
      :items="corpUser"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          small
          icon
          @click="$router.push(`/app/corpUser/details/${item.corpUsersId}`)"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <!-- <v-btn small icon @click="$router.push(`/app/corpUserForm/add`)">
          <v-icon>mdi-eye</v-icon>
        </v-btn> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    corpUser: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    headers: [
      {
        text: "CorpUsers Id",
        value: "corpUsersId",
      },
      {
        text: "User Id",
        value: "user.userId",
      },
      {
        text: "Supplier Id",
        value: "supplierInternalId",
      },
      {
        text: "Last Edited Date",

        value: "user.lastModifiedDate",
      },
      {
        text: "User Email",
        sortable: false,
        value: "user.email",
      },
      {
        text: "---",
        sortable: false,
        value: "action",
      },
    ],
  }), // data
};
</script>